<!--  -->
<template>
<div class='' style="height:90%">
  <div style="margin-bottom:10px;display:flex;justify-content:flex-start;">
    <div style="width:300px;display:flex;justify-content:space-between;">
      <el-input v-model="condition.title" placeholder="请输入查询内容"></el-input> <el-button type="success" size="mini" @click="queryByTitle()" round>搜索</el-button>
    </div>
  </div>
  <el-table
    :data="tableData.list"
    style="width: 100%;height:85%;overflow: scroll;">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item label="操作数据:">
            <span>{{ props.row.args==null?'无操作数据':props.row.args}}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
    <el-table-column
      prop="name"
      label="管理员"
      width="180">
    </el-table-column>
    <el-table-column
      prop="ip"
      label="ip地址"
      width="500">
    </el-table-column>
    <el-table-column
      prop="opt"
      label="操作行为"
      width="500">
    </el-table-column>
    <el-table-column
      prop="createTime"
      label="操作时间"
      sortable
      width="500">
    </el-table-column>
  </el-table>
   <el-pagination
        background
        style="margin-top:10px"
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :total="tableData.totalCount"
        :page-size="tableData.pageSize">
  </el-pagination>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { queryList } from '../../../api/admin/optLogger';
export default {
//import引入的组件需要注入到对象中才能使用
components: {},
data() {
//这里存放数据
return {
  condition:{
    current:1,
    size:12,
    title:""
  },
  tableData:{
    totalCount:1,
    pageSize:1,
    totalPage:1,
    currPage:1,
    list:[]
  },
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  queryByTitle(){
        var _this = this
        _this.condition.current=1
        queryList(_this.condition).then(({data})=>{
          _this.tableData=data
        })
   },
  handleCurrentChange(val){
    var _this =this
    _this.condition.current = val
    queryList(_this.condition).then(({data})=>{
    _this.tableData=data
   })
  },
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
  var _this = this
  queryList(_this.condition).then(({data})=>{
  if(data!=null){
  _this.tableData = data
  // _this.tableData.list.sort((a,b)=>{
  //   return Date.parse(b.createTime) - Date.parse(a.createTime)
  // })
  }
 })
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss'>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
 .demo-table-expand {
    font-size: 0;
  }
  .el-form-item__label {
    width: 90px;
    color: #86898c !important;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>